import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PERMISSION_HO_TEAM_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-content-inbox-edition',
  templateUrl: './home-content-inbox-edition.component.html',
  styleUrls: ['./home-content-inbox-edition.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentInboxEditionComponent implements OnInit {
  @Input() handoversEdition: Handover[] | undefined;
  @Input() totalHandoversEdition: number | undefined;
  @Input() searchEditionPersonal: string | undefined;
  @Output() reloadEdition = new EventEmitter<boolean>();
  @Output() eventShowInboxEdition = new EventEmitter<boolean>();
  @Output() handoversEditionPersonalWithFilter = new EventEmitter<string>();

  canPermissionTeam = false;
  textSearch = '';
  constructor(private userService: UserService) {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    this.canPermissionTeam = this.userService.hasPermission(
      PERMISSION_HO_TEAM_ID
    );
    this.textSearch = this.searchEditionPersonal
      ? this.searchEditionPersonal
      : '';
  }

  eventReload(reload: boolean) {
    this.reloadEdition.emit(true);
  }
  showInboxEdition() {
    this.eventShowInboxEdition.emit(false);
  }

  getHandoversHomeEditionPersonalWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversEditionPersonalWithFilter.emit(searchText);
  }
}
